import { InvoiceSourceType, InvoiceStatus } from "@mimber/schema"

export const SOURCE_LABELS: Record<InvoiceSourceType, string> = {
  [InvoiceSourceType.MEMBERSHIP_TIER]: "Dues",
  [InvoiceSourceType.DONATION]: "Donation",
  [InvoiceSourceType.CUSTOM]: "Custom",
  [InvoiceSourceType.PLATFORM_PLAN]: "Platform",
}

export const STATUS_COLORS: Record<InvoiceStatus, string> = {
  [InvoiceStatus.DRAFT]: "default",
  [InvoiceStatus.OPEN]: "blue",
  [InvoiceStatus.PAID]: "green",
  [InvoiceStatus.OVERDUE]: "red",
  [InvoiceStatus.VOID]: "default",
}
